import React from "react";
import "./Produto.css";
import { Link } from "react-router-dom";
import TextoTruncado from "../../utils/TruncarTexto";
import AdicionarAoCarrinhoBtn from "../AdicionarAoCarrinhoBtn";

const LivroAcademico = ({ livro, onAddToCartClick, slider, onAddToCartSlider }) => {
  const { id, titulo, image, preco } = livro;

  const scrollUp = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth", // Smooth scroll behavior
    });
  };
  const main = process.env.REACT_APP_MAIN;
  

  return (
    <>
      <div className="card-livro-academico">
        <Link to={main + 'livros/' + id} onClick={scrollUp}>
          <div className="card-img-container">
            <img
              className="img-produto"
              src={`https://insigneacademica.com.br/api/public/${image}`}
              alt={titulo}
            ></img>
          </div>
          <div className="card-detalhes">
            <h1>
              {" "}
              <TextoTruncado texto={titulo} limite={32}></TextoTruncado>
            </h1>
            <div className="card-info-autor"></div>
            <div className="card-outros-detalhes">
              <p>R$<span>
                {parseInt(preco)}</span></p>
            </div>
          </div>
        </Link>


        <AdicionarAoCarrinhoBtn ebook={livro} slider={slider}  onAddToCartSlider={onAddToCartSlider} />
      </div>
    </>
  );
};

export default LivroAcademico;
